export function paginationHandler() {
    this.$doc.ready(() => {
        if ( window.location.pathname.indexOf("/page/") < 0 || window.location.search === "" ) scroll(0,0);
        setTimeout( function () { scroll(0,0); }, 1);
        setTimeout(() => {
            let targetSection = $(".scroll-to-section").offset().top - this.$header.outerHeight() - 100;

            if (window.location.pathname.indexOf("/page/") >= 0 || window.location.search != "" ) {
                $("html, body").stop().animate({
                    "scrollTop": targetSection
                }, 1000);
            }
        }, 1000);
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/pagination-handler.js